// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HvrYW","index":"styles_index__2swUD"};